// extracted by mini-css-extract-plugin
var _1 = "ra-gallery-actions";
var _2 = "ra-gallery-actions-separator";
export { _1 as "artGalleryActionsCls", _2 as "artGalleryActionsSeparatorCls" }
